import {
  CityIcon,
  EditIcon,
  HomeIcon,
  LandingIcon,
  OccupantsFilledIcon,
  SwimIcon,
  ToolsFilledIcon,
  UserFilledIcon,
} from '@calizahq/react-components-v2'
import React from 'react'

import { AccessInstruction, UserType } from '@/types/Homes'

export const AccessInstructionListColumns = (
  handleEditInstruction: (accessInstruction: AccessInstruction) => void,
  isEditable: boolean,
) => {
  return [
    {
      Header: 'Details',
      accessor: 'instruction',
      width: 100,
      Cell: function _Cell({ row }: { row: { original: AccessInstruction } }) {
        return (
          <>
            {getAccessInstructionIcon(row.original.accessibleType)}
            {getUserTypeIcon(row.original.userType)}
            <div className="items-left ml-2 flex w-full flex-col justify-between" role="presentation">
              <p className="text-sm">{row.original.name}</p>
              <p className="text-xs text-tertiary">{row.original.instruction}</p>
            </div>
            {isEditable ? (
              <button
                className={'ml-2 mr-2 grid h-5 w-5 items-center justify-center'}
                onClick={() => handleEditInstruction(row.original)}
                title="Edit Issue"
              >
                <EditIcon className="text-blue-300" width={16} />
              </button>
            ) : null}
          </>
        )
      },
    },
  ]
}

export const getAccessInstructionIcon = (accessibleType: String) => {
  switch (accessibleType) {
    case 'Home': {
      return (
        <div title="Home Access">
          <HomeIcon className="mr-3 text-disabled" height={28} width={28} />
        </div>
      )
    }
    case 'Property': {
      return (
        <div title="Property Access">
          <CityIcon className="mr-3 text-disabled" height={28} width={28} />
        </div>
      )
    }
    case 'PropertyAmenity': {
      return (
        <div title="Property Amenity Access">
          <SwimIcon className="mr-3 text-disabled" height={28} width={28} />
        </div>
      )
    }
    default: {
      return <></>
    }
  }
}

export const getUserTypeIcon = (userType: UserType) => {
  switch (userType) {
    case UserType.MEMBER: {
      return (
        <div title="Member Access">
          <OccupantsFilledIcon className="mr-3 text-disabled" height={28} width={28} />
        </div>
      )
    }
    case UserType.HOST: {
      return (
        <div title="Host Access">
          <ToolsFilledIcon className="mr-3 text-disabled" height={28} width={28} />
        </div>
      )
    }
    case UserType.ADMIN: {
      return (
        <div title="Admin Access">
          <LandingIcon className="mr-3 text-disabled" height={28} width={28} />
        </div>
      )
    }
    case UserType.ANYONE: {
      return (
        <div title="Global Access">
          <UserFilledIcon className="mr-3 text-disabled" height={28} width={28} />
        </div>
      )
    }
    default: {
      return <></>
    }
  }
}
